// extracted by mini-css-extract-plugin
export default {"appShell":"Layout_appShell__C4OWV","mainArea":"Layout_mainArea__oNAZT","mainContent":"Layout_mainContent__YlqlY"};